module.exports = __webpack_public_path__ + "img/ps-24.000dd041.jpg";